import { render, staticRenderFns } from "./WebAd.vue?vue&type=template&id=dba22598&scoped=true&"
import script from "./WebAd.vue?vue&type=script&lang=js&"
export * from "./WebAd.vue?vue&type=script&lang=js&"
import style0 from "./WebAd.vue?vue&type=style&index=0&id=dba22598&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba22598",
  null
  
)

export default component.exports